<section class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-4">
        <div class="info-box ">
          <span class="info-box-icon bg-ua elevation-1"><i class="fas fa-city"></i></span>
          <div class="info-box-content">
            <span class="info-box-text">Total No. of Event</span>
            <span class="info-box-number">
              {{ orgCount? orgCount:0 }}
              <small></small>
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4">
        <div class="info-box ">
          <span class="info-box-icon bg-uaa elevation-1"><i class="fas fa-door-open"></i></span>
          <div class="info-box-content">
            <span class="info-box-text">Total No. of Gate</span>
            <span class="info-box-number">
              {{ gateCount? gateCount:0 }}
              <small></small>
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4">
        <div class="info-box ">
          <span class="info-box-icon bg-uc elevation-1"><i class="fas fa-users"></i></span>
          <div class="info-box-content">
            <span class="info-box-text">Total No of Attendees Assigned</span>
            <span class="info-box-number">
              {{ userCount? userCount:0 }}
              <small></small>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="sect">
      <div class="row">
        <div class="col-md-6 col-sm-6">
          <div class="row select">
            <div class="col-md-4">
              <div class="info-box-content padding">
                <span class="info-box-text">Select Event</span>
              </div>
            </div>
            <div class="col-md-8">
              <ng-select class="selectpicker selecterchart" [(ngModel)]="org_ref_id"
                (ngModelChange)="onOrgChange($event)" placeholder="Select Event">
                <ng-option value="">Select Event</ng-option>
                <ng-option *ngFor="let org of orgList; let i = index" [value]="org.id">{{ org.org_name }}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <div class=" col-md-6 col-sm-6 ">
          <div class="row select">
            <div class="col-md-4">
              <div class="info-box-content padding">
                <span class="info-box-text">Select Gate</span>
              </div>
            </div>
            <div class="col-md-8">
              <ng-select class="selectpicker selecterchart" [(ngModel)]="gate_ref_id"
                (ngModelChange)="onGateChange($event)" placeholder="Select Gate">
                <ng-option value="">Select Gate</ng-option>
                <ng-option *ngFor="let gate of gateList; let i = index" [value]="gate.id">{{ gate.gate_name
                  }}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-sm-6">
          <div class="row select">
            <div class="col-md-12">
              <div class="row data-info">
                <div class="col-md-6 col-sm-12"> <span>Event Name:
                  </span> {{this.org_name}}</div>
                <div class="col d-flex"><span>No of Attendees: </span> {{this.userCountOrg}} </div>
                <div class=" col-auto right">
                  <!-- <button *ngIf="this.userCountOrg>0" (click)="redirectToAssign(1)"
                        class="btn btn-sm btn-default mr-2 command-edit btn-margin ">
                        <em class="fa fa-user fa-fw"></em></button> -->
                  <button *ngIf="isShown2==true && this.userList.length>0" (click)="toggleShow(1)"
                    class="btn btn-sm btn-default mr-2 command-edit btn-margin ">
                    <em class="fa fa-eye fa-fw"></em></button>
                </div>


              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-6">
          <div class="row select">
            <div class="col-md-12">
              <div class="row data-info">
                <div class="col-md-6 col-sm-12"> <span>Gate Name:
                  </span> {{this.gate_name}}</div>
                <div class=" col d-flex"><span>No of Attendees: </span> {{this.userCountGate}} </div>

                <div class=" col-auto right">
                  <!-- <button *ngIf="this.userCountGate>0" (click)="redirectToAssign(2)"
                    class="btn btn-sm btn-default mr-2 command-edit btn-margin ">
                    <em class="fa fa-user fa-fw"></em></button> -->
                  <button *ngIf="isShown2==true && this.userCountGate>0" (click)="toggleShow(2)"
                    class="btn btn-sm btn-default mr-2 command-edit btn-margin ">
                    <em class="fa fa-eye fa-fw"></em></button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="sect">
      <div class="row">
        <div class="col-md-6 col-sm-6">
          <div class="row select">
            <div class="col-md-4">
              <div class="info-box-content padding">
                <span class="info-box-text">Select Day</span>
              </div>
            </div>
            <div class="col-md-8">
              <ng-select class="selectpicker selecterchart" [(ngModel)]="selected_Day"
                (ngModelChange)="onDayChange($event)" placeholder="Select Day">
                <ng-option value="">Select Day</ng-option>
                <ng-option value="1">Day 1</ng-option>
                <ng-option value="2">Day 2</ng-option>
                <ng-option value="3">Day 3</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <div class=" col-md-6 col-sm-6 ">
          <div class="row select">
            <div class="col-md-4">
              <div class="info-box-content padding">
                <span class="info-box-text">Select Dining</span>
              </div>
            </div>
            <div class="col-md-8">
              <ng-select class="selectpicker selecterchart" [(ngModel)]="selected_Dining"
                (ngModelChange)="onDiningChange($event)" placeholder="Select Dining">
                <ng-option value="">Select Dining</ng-option>
                <ng-option value="1">Breakfast</ng-option>
                <ng-option value="2">Lunch</ng-option>
                <ng-option value="3">Conversations Over Kahwa</ng-option>
                <ng-option value="4">Dinner</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="row select data-info">
            <div class="col-md-12">
              <div class="row data-info justify-content-between">

                <div class="col-auto"><span>Day: </span>Day {{selected_Day}}</div>
                <div class="col-auto"><span>No of Attendees: </span> {{this.diningUserCount}} </div>
                <div class="col-auto"><span>Dining: </span> {{this.Dining(selected_Dining)}} </div>
                <div class="col-auto"><span>No of Attendees Approved: </span> {{this.loggedDiningCount}}</div>
                <div class="col-auto right">
                  <button *ngIf="this.diningUserCount>0" (click)="redirectToAssign(3)"
                    class="btn btn-sm btn-default mr-2 command-edit btn-margin ">
                    <em class="fa fa-user fa-fw"></em></button>
                  <button *ngIf="isShown2==true && this.loggedDiningCount>0" (click)="toggleShow(3)"
                    class="btn btn-sm btn-default mr-2 command-edit btn-margin ">
                    <em class="fa fa-eye fa-fw"></em></button>
                </div>
                <!-- <div *ngIf="isShown2==true && this.loggedDiningCount>0 " class=" col"><button (click)="toggleShow(3)"
                    class="btn btn-sm btn-default mr-2 command-edit btn-margin ">
                    <em class="fa fa-eye fa-fw"></em></button></div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sect">
      <section class="content">
        <div class="container-fluid">

          <div class="box">
            <div class="box-body table-responsive">
              <table id="example1" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Sl.No</th>
                    <th *ngIf="userType!='superadmin'" class="width-th">
                      <ng-select class="selectpicker selecterchart plantpicker" [(ngModel)]="org_id"
                        (ngModelChange)="onEventChange($event)" appendTo="body">
                        <ng-option value="">Event Name</ng-option>
                        <ng-option *ngFor="let org of orgList; let i = index" [value]="org.id">{{ org.org_name
                          }}</ng-option>
                      </ng-select>
                    </th>
                    <th *ngIf="userType!='superadmin'" class="width-th">
                      <ng-select class="selectpicker selecterchart plantpicker" [(ngModel)]="gate_id"
                        (ngModelChange)="onGatesChange($event)" appendTo="body">
                        <ng-option value="">Gate Name</ng-option>
                        <ng-option *ngFor="let gate of gateList; let i = index" [value]="gate.id">{{ gate.gate_name
                          }}</ng-option>
                      </ng-select>
                    </th>
                    <th>User Name</th>
                    <th>Log Date Time</th>
                    <th>Approve Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let item of userList  | filter:searchInput | paginate: { itemsPerPage: limit, currentPage: page, totalItems: count } let i = index">
                    <td>{{ limit*(page-1)+(i+1) }}.</td>
                    <td>{{ item.org_name}}</td>
                    <td>{{ item.gate_name}}</td>
                    <td>{{ item.user_name}}</td>
                    <td>{{ item.created_at | date :"yyyy/MM/dd"}} at {{(item.created_at | date :"HH:mm")
                      }}{{(item.created_at | date :"HH")>11?' PM':' AM' }}</td>
                    <td><span [ngClass]="item.approved_status==1?'approved btn-success':'rejected'" class="open">{{
                        item.approved_status==1?'Approved':"Declined"}}</span></td>
                  </tr>
                </tbody>
              </table>
              <div class="paginate">
                <pagination-controls class="pagi" (pageChange)="paginate(page = $event)"></pagination-controls>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>